<canvas *ngIf="!readonly" #canvas class="signature-pad-canvas" (touchend)="endDrawing($event)"
    (mouseup)="endDrawing($event)"> </canvas>
<div *ngIf="!readonly" class="signature-info">{{ 'SIGNATURE.INFO' | translate}}</div>
<div *ngIf="!readonly" class="signature-clear" (click)="onClearSignature()">{{ 'SIGNATURE.CLEAR' | translate}}</div>
<ng-container *ngIf="!readonly && allowAttach">
    <input #attachInput type="file" class="signature-attach-input" accept="image/png,image/jpeg"
        (change)="onAttachImage($event)">
    <div class="signature-clear" (click)="attachInput.click()">{{ 'SIGNATURE.ATTACH' | translate}}</div>
</ng-container>
<img *ngIf="readonly && imageSrc" [src]="imageSrc" alt="Image" />
<div class="invalida no-justsignature">{{'SHARED.SIGNATURE.COMPONENT.INVALID.TITLE'|translate}}</div>